const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import ConfigPanel from "../ConfigPanel/ConfigPanel";
import EditChecker from '../../components/EditChecker/EditChecker';
//require("./shipmentStringMapping.less");
// Additional Imports...
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
//import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const methodNameHtml = require('./html/methodName.html');
const mapToShippingTypeHtml = require('./html/mapToShippingType.html');
const targetSelector = "#create-string-form";
// Modal Html to use

run(targetSelector, (el)=>{
  attachStubExample(el);
});

function attachStubExample(el) {
  // START: REQUIRED TO LOAD STUB
  const entryEl = $("<div class='entry-point'></div>");
  let text;
  if(el.data("edit-id") !='')
    text = 'Edit';
  else
    text = 'New';
  const mainHtml = render(
    require("./html/shipmentStringMapping.html"), {
    methodName: methodNameHtml,
    mapToShippingType: mapToShippingTypeHtml,
    text: text,
    editCheckerRedirect:el.data('cancel-url')
  }
  );
  const mainEl = $(mainHtml);
  $(el).html(entryEl);
  entryEl.append(mainEl);
  // END: REQUIRED TO LOAD STUB

  // START: REAL CODE
  const shipmentMethods = el.data('shipment-methods-list');
  const serviceLevels = el.data('service-level-list');
  const saveShippingStringMapping = el.data("url");
  const lookupLoadUrl = el.data("view-lookup-url");
  const customEditString = el.data("custom-edit-string");
  const editCode = el.data("edit-code");
  const editedShipmentMethod = el.data("edited-shipment-method");
  const shipmentMethodFlag = el.data("shipment-method-flag");
  const validateDuplicateCustomShippingStringUrl = el.data("validate-duplicate-custom-string-mapping-url");
  let isCustomStringDuplicate;
  let isCustomStringValid = false;
  let shipmentMethodBtnFlag = true;
  let els = {};
  let elsMap = {
    shippingMethodBtn: '.shipping-method-btn',
    serviceLevelsBtn: '.service-levels-btn',
    shippingMethodSection: '.shipping-method-section',
    serviceLevelSection: '.service-level-section',
    saveShippingMethodBtn: '.save-shipping-method-btn',
    shipmentMethodSelect: '#shipment-method-select',
    serviceLevelSelect: '#service-level-select'
  };

  function init() {
    setElements();
    bindElements();
    initConfigPanel();
    setupEditChecker();		
    // Stack function calls here.
    renderShipmentMethods();
    renderServiceLevels();
    setFieldsForEdit();
  }

  function setElements() {
    setElementsFromScope(els, elsMap, mainEl);
    // Can call multiple setElementsFromScope for multiple elsMap.
  }

  function bindElements() {
    els.shippingMethodBtn.on("click", function(){
      shipmentMethodBtnFlag = true;
      shippingMethod();
    });

    els.serviceLevelsBtn.on("click", function(){
      shipmentMethodBtnFlag = false;
      serviceLevel();
    });
    mainEl.on('blur', '.customeShippingString', valdateCustomShippingString);
    els.saveShippingMethodBtn.click(saveCustomeStringMappingAfterValidate);
    els.serviceLevelSection.hide();

  }

  function setupEditChecker() {
    EditChecker.bindCancelButton(".cancel-shipping-method-btn");
  }

  function saveCustomeStringMappingAfterValidate(){
    if(isCustomStringValid){
      saveCustomeStringMapping();
    }
  }

  function valdateCustomShippingString(){
    
    let customShippingString = $(".customeShippingString").val();
    const errorMsgEl = el.find("#custom-string-mapping-invalid");
    const dupMsgEl = el.find("#custom-string-mapping-already-exist");
    const predefinedShmFScMsgEl = el.find("#custom-string-mapping-predefined-shm-exist");
    let patternMatcher = new RegExp('[a-zA-Z0-9_\\-\\.,(){}[\\] \]', 'g');
    let arrmatch;
    let charCount = 0;
    $.ajax({
      data: {
        customStringName: customShippingString
      },
      url: validateDuplicateCustomShippingStringUrl,
      dataType: "JSON",
      type: 'POST',
      success: function (data) {
        isCustomStringDuplicate = data.response;
        let fscShipmentMethod = data.responseFsc;
        while ((arrmatch = patternMatcher.exec(customShippingString)) !== null) {
            charCount++;
        }
        if(customShippingString.trim() == "" || customShippingString.length != charCount || customShippingString.length > 100){
          isCustomStringValid = false;
          errorMsgEl.show()
          dupMsgEl.hide()
          predefinedShmFScMsgEl.hide()
          return false;
        } else if((editedShipmentMethod == "" && isCustomStringDuplicate != "") 
          || (editedShipmentMethod != "" && isCustomStringDuplicate != "" && editedShipmentMethod != isCustomStringDuplicate)){
          isCustomStringValid = false;
          dupMsgEl.show()
          errorMsgEl.hide()
          predefinedShmFScMsgEl.hide()
          return false;
        } else if(fscShipmentMethod != ""){
          isCustomStringValid = false;
          errorMsgEl.hide()
          dupMsgEl.hide()
          predefinedShmFScMsgEl.show()
          return false;
        }else{
          isCustomStringValid = true;
          errorMsgEl.hide()
          dupMsgEl.hide()
          predefinedShmFScMsgEl.hide()
          return true;
        }
        
      }
    });
  }

  function setFieldsForEdit(){
            if(editedShipmentMethod != ""){
                $(".customeShippingString").val(customEditString);
                if(shipmentMethodFlag == true){
                    els.shippingMethodBtn.addClass('active');
                    shippingMethod();
                    els.shipmentMethodSelect.val(editCode).trigger("change");

                }
                else{
                    els.shippingMethodBtn.removeClass('active');
                    els.serviceLevelsBtn.addClass('active');
                    serviceLevel();
                    els.serviceLevelSelect.val(editCode).trigger("change");
                }
                $('.shipping-method-btn-toggler-section').hide();
                els.shipmentMethodSelect.prop("disabled", true);
                els.serviceLevelSelect.prop("disabled", true);
            }
  }
  function saveCustomeStringMapping() {
        const submitModalFlow = new SubmitModalFlow({
            confirmModalTitle: "Save Shipment Method",
            confirmModalBody: '<div class="q-pad-all-xl">Once this custom shipping method is saved it will be availabe to use for orders. </div>',
            confirmModalBtnText: "Save",
            onConfirmClick: function () {
             submitModalFlow.showLoadingModal();
             saveCustomString({url: saveShippingStringMapping, success: success, error: error});
         
                function saveCustomString({url, success, error}){
                  let shippingMethodCode, shippingMethod;
                  if(shipmentMethodBtnFlag){ 
                    shippingMethodCode = els.shipmentMethodSelect.val();
                    shippingMethod = $( "#shipment-method-select option:selected" ).text();
                  }
                  else{
                    shippingMethodCode = els.serviceLevelSelect.val();
                    shippingMethod = $( "#service-level-select option:selected" ).text();
                  }
                    $.ajax({
                        data:{
                            "shipmentMethodBtnFlag": shipmentMethodBtnFlag,
                            "shippingMethodCode": shippingMethodCode,
                            "customStringName": $(".customeShippingString").val(),
                            "shippingMethod": shippingMethod,
                            "editedShipmentMethod": editedShipmentMethod
                        },
                        url: url,
                        dataType:"JSON",
                        type: 'POST',
                        success: success,
                        error: error
                    });
                }
                function success(response){
                    EditChecker.setPageClean();
                    if(response.status == "Success"){
                    submitModalFlow.showSuccessModal();
                    }
                    else{
                      submitModalFlow.showFailureModal();
                    }
                    setTimeout(function() {
                     }, 3000);
                     //Redirect to lookup page
                     location.href = lookupLoadUrl;
                }
                function error(){
                    submitModalFlow.showFailureModal();
                }
            }
          });
          submitModalFlow.init();
          submitModalFlow.showConfirmModal();
};

  function renderShipmentMethods(){
    shipmentMethods.forEach(function (shipmentMethod) {
      let option = $('<option />');
      option.attr('value', shipmentMethod.cdmValue).text(shipmentMethod.cdmMeaning);
      els.shipmentMethodSelect.append(option);
    });
  }

  function renderServiceLevels(){
    $(serviceLevels).each(function () {
      let option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.serviceLevelSelect.append(option);
    });
  }

  function initConfigPanel() {
    // Instantiate config panel here. Component has already been imported at the top.

  }

  //for the quickbtnGroup
  const shippingMethodBtnGrp = mainEl.find('.shipping-method-btn-toggler');
  const shippingMethodBtnToggler = new QuickBtnGroup(shippingMethodBtnGrp,{
    distributeWidth: true
  });
  shippingMethodBtnToggler.init();


  function shippingMethod(){
    els.shippingMethodSection.show();
    els.serviceLevelSection.hide();
  };

  function serviceLevel(){
    els.serviceLevelSection.show();
    els.shippingMethodSection.hide();
  };


  init();

  // END: REAL CODE
};


// WEBPACK FOOTER //
// ./src/pages/shipmentStringMapping/shipmentStringMapping.js